import { TextSmall } from '@/components/Texts';
import React from 'react';

const NoAutomatedDecisionMaking = () => {
  return (
    <>
      <TextSmall fontWeight={700}>
        (9) No automated decision making (including profiling).
      </TextSmall>
      <TextSmall>
        We do not intend to use any personal data collected from you for any
        automated decision making process (including profiling).
      </TextSmall>
    </>
  );
};

export default NoAutomatedDecisionMaking;
